module.exports = __webpack_public_path__ + "name=img/src/assets/icons/ic_mail.svg?007db9c743d66a0dfce6133a4b42338c";